import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-221cc23c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainViewFilter scrollableDiv-filter scrollBar" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "facilitiesFilter-dashboard-label"
}, "Facilities:", -1))
const _hoisted_6 = { class: "close-parent multiselect-scroll" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "clustersFilter-dashboard-label"
}, "Service Lines:", -1))
const _hoisted_9 = { class: "close-parent multiselect-scroll" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "departmentFilter-dashboard-label"
}, "Departments:", -1))
const _hoisted_12 = { class: "close-parent multiselect-scroll" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 0,
  href: "#",
  class: "modaltoolbarIcon neu-tooltip",
  style: {"cursor":"pointer","color":"#3673AA"},
  onclick: "window.open('https://mediaconnect.app.medcity.net/embed?id=d2266b54-bcf6-47b2-92bd-6572385bcde3', '', 'addressbar=false,toolbar=false,width=900,height=600,left=200,top=200,resizable=yes,title=Learn How')"
}
const _hoisted_15 = { "aria-hidden": "true" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, [
  /*#__PURE__*/_createTextVNode("Click to learn how"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("to use Filters")
], -1))
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  class: "control-label",
  id: "chkCurrent-label"
}
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = {
  class: "control-label",
  id: "chkNext-label"
}
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = {
  class: "control-label",
  id: "chkPrevious-label"
}
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "shiftTypesFilter-dashboard-label"
}, "Shift Summary:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "All Shifts...", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "dtStart-label"
}, "Start:", -1))
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "dtEnd-label"
}, "End:", -1))
const _hoisted_34 = {
  class: "row text-center",
  style: {"margin-top":"20px","margin-bottom":"10px"}
}
const _hoisted_35 = {
  class: "btn-group",
  role: "group",
  "aria-label": "..."
}
const _hoisted_36 = { "aria-hidden": "true" }
const _hoisted_37 = { "aria-hidden": "true" }
const _hoisted_38 = { "aria-hidden": "true" }
const _hoisted_39 = { "aria-hidden": "true" }
const _hoisted_40 = { "aria-hidden": "true" }
const _hoisted_41 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_checkbox = _resolveComponent("neu-checkbox")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedFacilities,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacilities) = $event)),
                _ctx.selectedFacilityChanged
              ],
              options: _ctx.facilities,
              multiple: true,
              searchable: true,
              "close-on-select": true,
              placeholder: "Select Facilities",
              label: "Text",
              "track-by": "Text",
              id: "selFacilities"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]),
            (_ctx.selectedFacilities != null && _ctx.selectedFacilities.length > 0)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "close-child",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFacilityDropdown && _ctx.resetFacilityDropdown(...args)))
                }, "X"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedClusters,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedClusters) = $event)),
                _ctx.selectedClusterChanged
              ],
              options: _ctx.clusters,
              multiple: true,
              searchable: true,
              "close-on-select": true,
              placeholder: "Select Service Lines",
              label: "Text",
              "track-by": "Text",
              id: "selClusters"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]),
            (_ctx.selectedClusters != null && _ctx.selectedClusters.length > 0)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "close-child",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetServiceLineDropdown && _ctx.resetServiceLineDropdown(...args)))
                }, "X"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.selectedDepartments,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDepartments) = $event)),
                _ctx.selectedDeptChanged
              ],
              options: _ctx.departments,
              multiple: true,
              searchable: true,
              "close-on-select": true,
              placeholder: "Select Departments",
              label: "Text",
              "track-by": "Text",
              id: "selDepartments"
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"]),
            (_ctx.selectedDepartments != null && _ctx.selectedDepartments.length > 0)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "close-child",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetDepartmentDropdown && _ctx.resetDepartmentDropdown(...args)))
                }, "X"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_13,
          (_ctx.profileData.TrainingEnabled)
            ? (_openBlock(), _createElementBlock("a", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'fa-video'],
                    size: "lg"
                  }),
                  _createTextVNode(" Learn How ")
                ]),
                _hoisted_16
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, [
            _createVNode(_component_neu_checkbox, {
              id: "chkCurrent",
              name: "chkCurrent",
              class: "mr-10",
              modelValue: _ctx.isCurrentShiftChecked,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isCurrentShiftChecked) = $event))
            }, null, 8, ["modelValue"]),
            _createTextVNode("Current Shift ")
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, [
            _createVNode(_component_neu_checkbox, {
              id: "chkNext",
              name: "chkNext",
              class: "mr-10",
              modelValue: _ctx.isNextShiftChecked,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isNextShiftChecked) = $event))
            }, null, 8, ["modelValue"]),
            _createTextVNode("Next Shift ")
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, [
            _createVNode(_component_neu_checkbox, {
              id: "chkPrevious",
              name: "chkPrevious",
              class: "mr-10",
              modelValue: _ctx.isPreviousShiftChecked,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isPreviousShiftChecked) = $event))
            }, null, 8, ["modelValue"]),
            _createTextVNode("Previous Shift ")
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _hoisted_26,
          _withDirectives(_createElementVNode("select", {
            name: "ddlShiftSummary",
            class: _normalizeClass(['neu-select', !_ctx.dateRangesEnabled ? 'neu-input--disabled':'']),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedSummaries) = $event)),
            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.summaryChanged())),
            disabled: !_ctx.dateRangesEnabled
          }, [
            _hoisted_28,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaries, (smry) => {
              return (_openBlock(), _createElementBlock("option", {
                value: smry.Value,
                key: smry.Value
              }, _toDisplayString(smry.Text), 9, _hoisted_29))
            }), 128))
          ], 42, _hoisted_27), [
            [_vModelSelect, _ctx.selectedSummaries]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.startDateTime,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startDateTime) = $event)),
            weekStart: "0",
            class: "datePickerWidth",
            disabled: !_ctx.dateRangesEnabled,
            autoApply: ""
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.endDateTime,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endDateTime) = $event)),
            weekStart: "0",
            class: "datePickerWidth",
            disabled: !_ctx.dateRangesEnabled,
            autoApply: ""
          }, null, 8, ["modelValue", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        (_ctx.isShowPrintBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link col-md-2",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.loadDailyRosterFilterReport && _ctx.loadDailyRosterFilterReport(...args)))
            }, [
              _createElementVNode("i", _hoisted_36, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'print'],
                  size: "lg"
                })
              ]),
              _createTextVNode(" Print ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveFilters && _ctx.saveFilters(...args))),
          class: "btn btn-link col-md-3"
        }, [
          _createElementVNode("i", _hoisted_37, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'save'],
              size: "lg"
            })
          ]),
          _createTextVNode(" Save Filter ")
        ]),
        _createElementVNode("button", {
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.preferenceSettings && _ctx.preferenceSettings(...args))),
          class: "btn btn-link col-md-3"
        }, [
          _createElementVNode("i", _hoisted_38, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'cog'],
              size: "lg"
            })
          ]),
          _createTextVNode(" My Settings ")
        ]),
        _createVNode(_component_neu_button, {
          type: "button",
          fill: "raised",
          class: "col-md-3 padding0",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.applyFilters('btnclick', 0)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", _hoisted_39, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'filter'],
                size: "lg"
              })
            ]),
            _createTextVNode(" Apply Filters ")
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args))),
          class: "btn btn-link col-md-3"
        }, [
          _createElementVNode("i", _hoisted_40, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'undo'],
              size: "lg"
            })
          ]),
          _createTextVNode(" Reset Filters ")
        ])
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ]))
}